import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { ComplianceAction } from 'src/app/core-module/models/Audits/compliance-action';
import { Question } from 'src/app/core-module/models/Audits/question';
import { StandardQuestionEntry } from 'src/app/core-module/models/Audits/standard-question-entry';
import { validDateGreaterThan } from 'src/app/core-module/models/Utils/Validators/validDateGreaterThan';
import { validForbiddenValues } from 'src/app/core-module/models/Utils/Validators/validForbiddenValues';
import { validRequiredValues } from 'src/app/core-module/models/Utils/Validators/validRequiredValue';
import { BasicUser } from 'src/app/core-module/models/basic-user';
import { UserService } from 'src/app/core-module/services/user.service';
import { UtilService } from 'src/app/core-module/services/util.service';

@Component({
    selector: 'app-question-action',
    templateUrl: './question-action.component.html',
    styleUrls: ['./question-action.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class QuestionActionComponent {

   eventsSubject: Subject<void> = new Subject<void>();
  private lastQuestionId: number = -1;

  constructor(private formBuilder: FormBuilder, private userService: UserService, private util:UtilService) { }

  @Input() currentQuestion: Question = new Question();
  @Input() actionUsers:BasicUser[] = [];
  @Output() currentQuestionChange = new EventEmitter<Question>();

  public currentAction: ComplianceAction = new ComplianceAction();
  public otherAction: boolean = false;
  public _users: BasicUser[] = [];
  public av: actionValidator = new actionValidator();
  public standardActions: ComplianceAction[];
  public isEdit: boolean = false;

  public actionHolder: StandardQuestionEntry = new StandardQuestionEntry();
  //Possible remove
  public isSubmitCheck: boolean = false;
  public actionValid:boolean = true;
  public actionDateValid:boolean = true;

  ngOnInit() {
    //this._users = this.actionUsers.sort((a, b) => { if (a.UserTypeID == b.UserTypeID) { return a.DisplayName.localeCompare(b.DisplayName) } else { return b.UserTypeID - a.UserTypeID } });
    this.setUserDDL();
    this.lastQuestionId = this.currentQuestion?.QuestionID ?? -1;
    this.applyDefaultActionDeadline();
    this.av.actionNote = new FormControl(this.currentAction.ActionNote, [Validators.required, Validators.minLength(5)]);
    this.av.actionDate = new FormControl(this.currentAction.ActionDeadline, [Validators.required, validDateGreaterThan(true)]);
    this.av.actionUser = new FormControl(this.currentAction.ActionOwner.UserID, [Validators.required, validForbiddenValues(/-1/i)]);
    this.av.actionID = new FormControl(this.currentAction.ActionID, [Validators.required, validForbiddenValues(/-1/i)]);
    this.av.actionOther = new FormControl(this.otherAction, [validRequiredValues(/True/i)]);
  }
  ngOnChanges() {
    const nextQuestionId = this.currentQuestion?.QuestionID ?? -1;
    if (nextQuestionId !== this.lastQuestionId) {
      this.lastQuestionId = nextQuestionId;
      this.resetActionDisplay();
      return;
    }
    this.resetDDL();
    this.applyDefaultActionDeadline();
  }
  resetDDL() {
    this.setActionDDL();
    this.setUserDDL();
  }
  setActionDDL() {
    if(this.currentQuestion.StandardActions.some(e => {e.StandardQuestionEntryID != -1})){
      this.otherAction = false;
    }else{
      this.otherAction = true;
    }
    if (this.currentQuestion.StandardActions.some(e => { e.IsDefault })) {
      this.currentAction.StandardAction = this.currentQuestion.StandardActions.find(f => { f.IsDefault })!;
    } else {
      if (!this.currentQuestion.StandardActions.some(e => e.StandardQuestionEntryID == -1)) {
        var newAction = new StandardQuestionEntry({ 'StandardQuestionEntryID': -1, 'StandardEntryText': 'Please Select...' });
        this.currentQuestion.StandardActions.unshift(newAction)
      }
      this.currentAction.StandardAction = this.currentQuestion.StandardActions.find(e => { return e.StandardQuestionEntryID == -1 })!;
    }
  }
  setUserDDL() {
    if(this.actionUsers.length>0){
      this.currentAction.ActionOwner = this.actionUsers.find(e => { return e.UserID == -1 })!;
    }
    
  }
  resetActionDisplay() {
    this.currentAction = new ComplianceAction();
    this.otherAction = false;
    this.isEdit = false;
    this.actionValid = true;
    this.actionDateValid = true;
    this.isSubmitCheck = false;
    this.resetDDL();
    this.applyDefaultActionDeadline();
  }
  addAction() {
    this.isSubmitCheck = true;
    if(this.validateAction()){
      this.currentQuestion.CompletionInfo.Actions.push(this.currentAction);
      this.resetActionDisplay();
      this.currentQuestionChange.emit(this.currentQuestion);
    }
  }
  validateAction(){
    this.updateFormValidation();
    this.actionValid = this.currentAction.ActionOwner?.UserID !== -1;
    this.actionDateValid = this.isValidDeadline(this.currentAction.ActionDeadline);
    return this.actionValid && this.actionDateValid;
  }
  saveAction() {
    this.isSubmitCheck = true;
    if(this.validateAction()){
      this.currentQuestion.CompletionInfo.Actions[this.returnEditingIndex()] = this.currentAction;
      this.isEdit = false;
      this.resetActionDisplay();
      this.currentQuestionChange.emit(this.currentQuestion);
    }

  }
  editAction(CA: ComplianceAction) {
    this.currentAction = new ComplianceAction(CA);
    this.otherAction = (CA.StandardAction.StandardQuestionEntryID == -1);
    this.actionValid = true;
    this.actionDateValid = this.isValidDeadline(this.currentAction.ActionDeadline);
    this.isSubmitCheck = false;
    this.isEdit = true;
  }
  actionComparison(a: StandardQuestionEntry, b: StandardQuestionEntry): boolean {
    if(a==undefined || b==undefined || a==null || b==null){
      return false;
    }
    return a.StandardQuestionEntryID == b.StandardQuestionEntryID;
  }
  userComparison(a: BasicUser, b: BasicUser): boolean {
    if(a==undefined || b==undefined || a==null || b==null){
      return false;
    }
    return (a.UserID == b.UserID && a.UserTypeID == b.UserTypeID)
  }
  deleteAction() {
    if (this.isEdit) {
      var index: number = this.returnEditingIndex()
      if (index != -1) {
        this.currentQuestion.CompletionInfo.Actions.splice(index, 1);
      }      
    }
    this.resetActionDisplay();
    this.currentQuestionChange.emit(this.currentQuestion);
  }
  returnEditingIndex(): number {
    return this.currentQuestion.CompletionInfo.Actions.findIndex(e => {
      return e.Editing
    });
  }
  updateFormValidation() {

    this.av.actionDate.setValue(this.currentAction.ActionDeadline);
    this.av.actionID.setValue(this.currentAction.ActionID);
    this.av.actionNote.setValue(this.currentAction.ActionNote);
    this.av.actionUser.setValue(this.currentAction.ActionOwner.UserID);
    this.av.actionOther.setValue(this.otherAction);
  }

  hasDefaultAction(): boolean {
    return this.currentQuestion?.StandardActions?.some(e => e.StandardQuestionEntryID !== -1) ?? false;
  }

  private applyDefaultActionDeadline() {
    const defaultDays = Number(this.currentQuestion?.DefaultResolutionPeriod ?? 0);
    if (defaultDays <= 0 || this.isEdit || this.currentAction.Editing) {
      return;
    }
    if (this.currentAction.ActionID !== -1) {
      return;
    }
    const baseDate = new Date();
    const dueDate = new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate());
    dueDate.setDate(dueDate.getDate() + defaultDays);
    this.currentAction.ActionDeadline = this.util.removeTimezoneFromDate(dueDate);
    if (this.av?.actionDate) {
      this.av.actionDate.setValue(this.currentAction.ActionDeadline);
    }
  }

  onDateChange(event: Date | null){
    if (!event) {
      (this.currentAction as { ActionDeadline: Date | null }).ActionDeadline = null;
      this.actionDateValid = false;
      this.av?.actionDate?.setValue(null);
      return;
    }
    const localDate = this.util.removeTimezoneFromDate(event);
    this.currentAction.ActionDeadline = localDate;
    this.actionDateValid = this.isValidDeadline(localDate);
    this.av?.actionDate?.setValue(localDate);
  }

  private isValidDeadline(value: Date | string | null | undefined): boolean {
    if (!value) {
      return false;
    }
    const date = new Date(value);
    return !isNaN(date.getTime()) && date.getFullYear() >= 2000;
  }

}

class actionValidator {
  actionNote: FormControl;
  actionID: FormControl;
  actionDate: FormControl;
  actionUser: FormControl;
  actionOther: FormControl;
  isValid() {
    if (this.actionOther.valid) {
      return this.actionNote.valid && this.actionDate.valid && this.actionUser.valid;
    } else {
      return this.actionDate.valid && this.actionUser.valid && this.actionID.valid;
    }
  }
}

